import { render, staticRenderFns } from "./DatePickerNepali.vue?vue&type=template&id=9d9ed8ea&"
import script from "./DatePickerNepali.vue?vue&type=script&lang=js&"
export * from "./DatePickerNepali.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerNepali.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports